import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { RepresentativeType } from "../../types/entitiesModel";
import { useNavigate } from "react-router-dom";
import BorderColorIcon from "@mui/icons-material/BorderColor";

interface AppTableProps {
  data: RepresentativeType[];
}

const AppTableRepresentatives: React.FC<AppTableProps> = (
  props: AppTableProps
) => {
  const navigate = useNavigate();

  const handleEditUser = (id: number) => {
    navigate(`/admin/representatives/editRepresentative/${id.toString()}`);
  };

  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3">Representantes</Typography>
          <Box
            sx={{
              overflowX: "auto",
              width: "100%",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                mt: 3,
                whiteSpace: "nowrap",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Id
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Nombre
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Documento
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Relación
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Teléfono
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography color="textSecondary" variant="h6">
                      Correo
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography color="textSecondary" variant="h6">
                      Editar
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data.map((rep: RepresentativeType) => (
                  <TableRow key={rep.id}>
                    <TableCell>
                      <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>
                        {rep.id}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {rep.name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {rep.document}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {rep.relationship}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {rep.phone}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {rep.email}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Fab
                        color="success"
                        aria-label="edit"
                        sx={{
                          width: 35,
                          height: 35,
                          cursor: "pointer",
                          backgroundColor: "green",
                          "&:hover": {
                            backgroundColor: "darkgreen",
                          },
                        }}
                        onClick={() => {
                          handleEditUser(rep.id);
                        }}
                      >
                        <BorderColorIcon
                          sx={{
                            width: 20,
                            height: 20,
                            widhtcolor: "white",
                          }}
                        />
                      </Fab>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AppTableRepresentatives;
